import Yup from "../../../utilities/yupExtensions";

// export const singleClientReportPersonValidationSchema = Yup.object()
//   .shape({
//     firstName: Yup.string().min(2).label("First Name"),
//     lastName: Yup.string().min(2).label("Last Name"),
//   })
//   .atLeastOneOf(
//     ["firstName", "middleName", "lastName", "clientOfferId", "clientNumber"],
//     "At least one of [First Name], [Middle Name], [Last Name], [Offer ID], [Client EGN] filters is required"
//   );

// export const singleClientReportCompanyValidationSchema = Yup.object()
//   .shape({
//     fullName: Yup.string().min(3).label("Company Name"),
//   })
//   .atLeastOneOf(
//     ["fullName", "clientOfferId", "clientNumber"],
//     "At least one of [Company Name], [Offer ID], [Company number] filters is required"
//   );

export const singleClientReportNoneSelectedValidationSchema = Yup.object().test(
  "atLeastOneField",
  null,

  function (values) {
    const hasError = Object.values(values).some(
      (value) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value.length !== 0
    );

    if (!hasError) {
      return this.createError({
        path: "atLeastOneField",
        message: "At least one field must have a value",
      });
    }

    return true;
  }
);



// WEBPACK FOOTER //
// ./src/features/reports/validation-schemas/singleClientEntriesReportSchema.js